import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rider-payor-detail-grid',
  templateUrl: './rider-payor-detail-grid.component.html',
  styleUrls: ['./rider-payor-detail-grid.component.scss']
})
export class RiderPayorDetailGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-payor-detail-grid/rider-payor-detail-grid.component.ts